module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABH0lEQVR4AeyV4RHBQBCFEw1QghLoQAl0QAWoBBWgAqMCOqADOqCD+J65H5fLYXIzh8mc2Wfty9p92dxOWtmPP0lAmsD/TaAoih5YGyzx3ZiL4pvAjoZjgyl+CaKZT4B7x+1o3SnsEwD9PUsCgifAdnTAwKAT+tCCBNBUB/VC04PByXCE9SxIAC0GwL5rCRIHXc9CBdTr8iY7CWj2BNgMvdh2+IPB0D0OsSewoKGaakOENXHJYgsoNSOwV5cwy74t4NnU/vpLAXdb4YvfVw9/83Burcr/fBPoU2gFNkB+gi9ZnudHCPHKEcZwezjX5hCqoRxhRFyyigAKXcEMTIB8RbUqcG0DlCNsxbngul1LeWc3pyLATYgdJwHNn8CnM/QAAAD//32fPs4AAAAGSURBVAMAialTQWDXi6EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhibo_shutiao_16@2x.png
// module id = 871
// module chunks = 1